/* rough explanation on the process
- on load of oasis, it will display the information via the liquid {{ element name }}
- on select of Type/Model Selection it will run Type Selection and display the Size of the selected Smart/Standard - the Type/Model is not part of the select options. it is static
  - select will add an active class to the correct 46/52 options. the words Standard and Smart are removed
- on select of color colors update the selected size/text depending on its type

on update:
- the main holder of information is the #currentSelection. it is where size, variant, handle is stored
- on click, the handle is updated and based on the handle, the image thumbnail of the same handle is clicked. this triggers the change of image and shows the correct combination
- since the handle is the basis to get the thumbnail, now using this the variant of the thumbnail is now taken and stored to currentSelection. the variant also will be updated to the add to cart / checkout btns
*/

jQuery( document ).ready(function($) {
    
    //load default image thumbnail and default bundle
    var Handle = $('#currentSelection').attr('data-handle');
    var colorCombi = $('#currentSelection').attr('data-color');
    var currentBundle = $('.oasis-image li[data-color= '+colorCombi+']').attr('data-bundled-variant-ids');
    var currentMotor = $('#currentSelection .housing').text().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    var currentBlade = $('#currentSelection .blade').text().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

    //initial grab and atome
    var voucherPrice = $('#voucher-price').text().replace('$', '');
    var origPrice = $('#ProductPrice-product-template').text().replace('$', '');
    if(voucherPrice != ''){
      var initialPrice = voucherPrice;
    }else{
      var initialPrice = origPrice;
    }
    var getGrab = $('.payment-alt-options .grab-info').attr("data-discount");
    var initialGrab = initialPrice / getGrab;
    var getAtome = $('.payment-alt-options .atome-info').attr("data-discount");
    var initialAtome = initialPrice / getAtome;
    $('.payment-alt-options .grab-info.price-value, .voucher-pricing .grabpay-content .price span').text(Math.ceil(initialGrab));
    $('.payment-alt-options .atome-info.price-value').text(Math.ceil(initialAtome));
  
    //initial bundle
    $('#currentSelection').attr("data-bundle", currentBundle);
    $('.oasis-image li.' + Handle + ' a').addClass('active-thumb');
    $('.oasis-image li.' + Handle).addClass('active');
    $('.variant-select.housing-gp li.' + currentMotor).addClass('active');
    $('.variant-select.blade-gp li.' + currentBlade).addClass('active');
    $('.oasis-image li[data-color= '+colorCombi+'], .voucher-pricing .tooltip .flex-wrap .part1 p.code .grab.grab-smart').addClass('active');
    setTimeout(function () {
        $('.size-gp.smart-52').click();
    }, 50);

    //Type Selection
    $( ".oasis-select .selection li" ).click(function() {
      var clickedType = $(this).attr("data-type");
      var clickedType2 = clickedType.toLowerCase();
      var currentSize = $('#currentSelection .type').attr('data-size');
      //console.log(clickedType);
      //console.log(currentSize);
      $(".oasis-select .selection li").removeClass('active');
      $(this).addClass('active');
      $('.variant-select ul li.size-op').removeClass('show');
      $('.variant-select ul li.size-op.'+ clickedType).addClass('show');
      $('.variant-select ul li.'+ clickedType2 + '-' + currentSize).addClass('active');

      $('#currentSelection .type').attr("data-size", currentSize);
      $('#currentSelection .type').val(clickedType);
      $('#currentSelection .type').text(clickedType + ' ' + currentSize +'"');

      updateAll();
    });
  
    //Size Selection
    $( "ul.size-gp li" ).click(function() {
      var updateSize = $(this).attr("data-size");
      //console.log(clickedType);
      $('#currentSelection .type').attr("data-size", updateSize);

      updateAll();
    });

    //Options Selection
    $( ".variant-select ul li" ).click(function() {
      var clickedItem = $(this).attr("value");
      var clickedType = $(this).attr("data-type");

      if(clickedType == 'housing-gp'){
        $('#currentSelection .housing').val(clickedItem);
        $('#currentSelection .housing').text(clickedItem);
        $('.variant-select .housing-gp.currentSelect').text(clickedItem.replace(' Motor',''));
        $('.housing-gp li.item').removeClass('active');
      }else{
        if(clickedType == 'blade-gp'){
          $('#currentSelection .blade').val(clickedItem);
          $('#currentSelection .blade').text(clickedItem);
          $('.variant-select .blade-gp.currentSelect').text(clickedItem.replace(' Blade',''));
          $('.blade-gp li.item').removeClass('active');
        }else{
          $('#currentSelection .type').val(clickedItem);
          $('#currentSelection .type').text(clickedItem);
          $('.size-gp li.item').removeClass('active');
        }
      }
      $(this).addClass('active');

      updateAll();
    });
/*
    //Variant Select VIA image click
    $( ".oasis-image li a" ).click(function() {
      var clickedSize = $(this).parent('li').attr("data-size");
      var clickedType = $(this).parent('li').attr("data-type");
      var clickedType2 = clickedType.toLowerCase();
      //var clickedHousing = $(this).parent('li').attr("data-housing");
      //ar clickedBlade = $(this).parent('li').attr("data-blade");
      
      //$('#currentSelection .housing').val(clickedHousing);
      //$('#currentSelection .housing').text(clickedHousing);
      //$('#currentSelection .blade').val(clickedBlade);
      //$('#currentSelection .blade').text(clickedBlade);
      //$('#currentSelection .type').val(clickedType);
     // $('#currentSelection .type').text(clickedType);
      //$('#currentSelection .type').attr('data-size', clickedSize);

      //$('.housing-gp li.item').removeClass('active');
      //$('.blade-gp li.item').removeClass('active');
      //$('.size-gp li.item').removeClass('active');
      //$('.size-gp li.'+clickedType).addClass('active');

      $(".oasis-select .selection li").removeClass('active');
      $('.oasis-select .selection li[data-type= '+clickedType+']').addClass('active');
      $('.variant-select ul li.size-op').removeClass('show');
      $('.variant-select ul li.size-op.'+ clickedType).addClass('show');
      $('.variant-select ul li.'+ clickedType2 + '-' + clickedSize).addClass('active');

      $('#currentSelection .type').attr("data-size", clickedSize);
      $('#currentSelection .type').val(clickedType);
      $('#currentSelection .type').text(clickedType + ' ' + clickedSize +'"');

      //console.log(clickedType);
      console.log(clickedSize);
      updateAll();
      
    });
*/
    $( ".oasis-bnpl-btn" ).click(function() {
  		$(".oasis-bnpl-modal").addClass("active");
      	var price = $('.grab-box').attr("data-price");
      	$('.grabpay-content .price span').text(price);

        $(".stockclose").addClass("show bgshow");
  	});  

    $( ".oasis-chart-modal-btn" ).click(function() {
  		$(".oasis-chart-modal").addClass("active");
        $(".stockclose").addClass("show bgshow");
  	});   
    $( ".oasis-size-modal-btn" ).click(function() {
  		$(".oasis-size-modal").addClass("active");
        $(".stockclose").addClass("show bgshow");
  	});   


    /* product slice section 6 - toggleswitch & content */
    $( ".togglesmart .switch li" ).click(function() {
      var clickedType = $(this).attr("data-type");
      //console.log(clickedType);
      $('.togglesmart .s-item').removeClass('active');
      $('.togglesmart .s-item.'+clickedType).addClass('active');
      $($(this)).addClass('active');
    });

    $('.oasis-select.model li.item.default').click();
});

function updateAll(){
  //create handle and update
  var Handle = $('#currentSelection').text(); //this is when changes was made to the text, then create the handle
  var updateHandle = Handle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''); 
  $('#currentSelection').attr("data-handle", updateHandle);

  //update image to selected
  var updateVariant = $('.oasis-image li.' + updateHandle).attr('data-variant');
  var updateColorCombi = $('.oasis-image li.' + updateHandle).attr('data-color');
  var updateBundle = $('.oasis-image li.' + updateHandle).attr('data-bundled-variant-ids'); //bundle ids added in the thumbnail list
  
  //console.log(updateVariant);
  $('.oasis-image li.' + updateHandle + ' a').trigger('click');
  $('.oasis-image li.' + updateHandle + ' a').addClass('active-thumb');
  $('.oasis-image li').removeClass('active');
  $('.oasis-image li.' + updateHandle).addClass('active');
  $('.oasis-image li[data-color= '+updateColorCombi+']').addClass('active');
  $('#currentSelection').attr("data-variant", updateVariant);
  $('#currentSelection').attr("data-color", updateVariant);
  $('#currentSelection').attr("data-bundle", updateBundle);

  //update pricing
  var updatePrice = $('.ProductSelect-product-template option[value= '+updateVariant+']').attr("data-myprice");
  var updateCompare = $('.ProductSelect-product-template option[value= '+updateVariant+']').attr("data-compare");
  var getVoucher = $('.ProductSelect-product-template option[value= '+updateVariant+']').attr("data-oasisVoucher");
  var oasisType = $('.ProductSelect-product-template option[value= '+updateVariant+']').attr("data-oasisType");
  var comparePercentage = $('.ProductSelect-product-template option[value= '+updateVariant+']').attr("data-compare-percentage");
  //var getVoucher = $('#voucher-price').attr("data-voucher");
  var updateVoucher = updatePrice - getVoucher;
  var getGrab = $('.payment-alt-options .grab-info').attr("data-discount");
  var updateGrab = updateVoucher / getGrab;
  var getAtome = $('.payment-alt-options .atome-info').attr("data-discount");
  var updateAtome = updateVoucher / getAtome;
  //console.log(getGrab);
  //console.log(getAtome);
  $('#voucher-price').text('$' +updateVoucher);
  // update climate voucher price
  $(".voucher-pricing .tooltip .voucher-wrap .voucher-price").html(`$${(Math.max(updateVoucher - window.cv_price, 0)).toLocaleString()}`);
  $('.product-form__cart span.voucher1').text('$' +updateVoucher);
  $('span#ProductPrice-product-template').text('$' +updatePrice);
  $('s#ComparePrice-product-template').text('$' +updateCompare);
  $('.payment-alt-options .grab-info.price-value, .voucher-pricing .grabpay-content .price span').text(Math.ceil(updateGrab));
  $('.payment-alt-options .atome-info.price-value').text(Math.ceil(updateAtome));
  if(oasisType == 'smart'){
    $('.voucher-pricing .tooltip .flex-wrap .part1 p.code .grab').removeClass('active');
    $('.voucher-pricing .tooltip .flex-wrap .part1 p.code .grab.grab-smart').addClass('active');
  }else if(oasisType == 'standard'){
    $('.voucher-pricing .tooltip .flex-wrap .part1 p.code .grab').removeClass('active');
    $('.voucher-pricing .tooltip .flex-wrap .part1 p.code .grab.grab-standard').addClass('active');
  }


  /* manually set pre-order on Oasis Blade 46" variants */
  //console.log('preorder run code');

  const currentBladeSize = $('.item.size-gp.show.active').data('size');
  const currentBladeColor = $('.blade-gp.currentSelect').text().trim();

  const currentModel = $('.oasis-select.model .selection li.active').data('type');
  const currentMotorColor = $('.housing-gp.active')
      ?.attr('data-size')
      ?.replace(' Motor','')
      ?.trim();

  //console.log(currentBladeColor);
  const preorderBladeColors = [

  ];

  const preorderMotor = [

  ];

  $(".motor-upgrade-message").remove();


// ====================================
// Oasis Manual Stock Overrides
// ====================================

// Reset to defaults first
$("#currentSelection")
    .attr(
        "data-stocknum",
        $("#currentSelection").attr("data-defstocknum") || "1"
    )
    .attr("data-restock", "Delivers 3-5 working days");

let preorder = false;

// ------------------------------------
// Oasis Blade 46" Pre-order
// ------------------------------------

if (
    currentBladeSize == "46" &&
    preorderBladeColors.includes(currentBladeColor)
) {
    preorder = true;
}

// ------------------------------------
// Oasis Motor Housing 46-52" LED - Matte White
// (Standard + Smart)
// ------------------------------------

if (preorderMotor.includes(currentMotorColor)) {
    preorder = true;
}

// ------------------------------------
// Apply preorder
// ------------------------------------

if (preorder) {

    $("#currentSelection")
    .attr("data-stocknum", "3")
    .attr("data-restock", "Arrives in Mid to Late August");
  
}

  
  

  $("span#compare_precntage, .comparetooltip").text(comparePercentage);
  
  //update atc button info from selection
  var updateAtc = $('.ProductSelect-product-template option[value= '+updateVariant+']').attr('data-atcbtn');
  var updateRestock = $('.ProductSelect-product-template option[value= '+updateVariant+']').attr('data-restock');
  var defRestock = $('#currentSelection').attr('data-restock');
  $('#currentSelection').attr("data-atc", updateAtc);
  //$('#currentSelection').attr("data-restock", updateRestock);
  
  //update form atc button  
  if(updateAtc != ''){
    $('.product-form__checkout').text(updateAtc);
  }else{
    $('.product-form__checkout').text('Buy Now');
  }
  

  if(updateRestock != ''){
    $('.oasis-form.product-restocks p').text(defRestock);
  }
  

  

  $('#currentSelection').attr("data-price", updatePrice);
  $('#currentSelection').attr("data-voucher", getVoucher);
  $('#currentSelection').attr("data-compare", updateCompare);

  updateStockIndicator();
}

/* ============================== 
    FIX FOR CUSTOM ADD TO CART
    MIX OF BUNDLES.JS AND POPUP FROM OMNIVERT
    This is due to the popup when add to cart is clicked
    - IF BUNDLES IS UPDATED, UPDATE HERE AS WELL
    
*/
var bundledVariants = [];

$(document).ready(function() {
	checkBundledVariants();
});

// Get bundled products on variant change to reduce impact on checkout speed.
$('#SingleOptionSelector-0').change(function() {
	//console.log('option changed');
	checkBundledVariants();
});
// for new product page item selection update
$('.customVariantBox .eachVariantBox').click(function(){
//   setTimeout(function(){ 
//     checkBundledVariants();
//   }, 100);

});
 
$('.upsellProductsContainer.upsellProducts').click(function(){
  setTimeout(function(){ 
    checkBundledVariants();
  }, 50);
});


function checkBundledVariants() {
	bundledVariants = []; // Reset bundled variants
	var variantTitle = $('#SingleOptionSelector-0').val();

	if($('#AirconSystemSelect-product-template').length){
      //var selectval = $("#AirconSystemSelect-product-template").val();
      var selectval = $('input[name="aircon_select"]:checked').val();
       if(selectval == 'System-2'){
         var variantId = $('.ProductSelect-product-template.system-2').val();
       
        }else if(selectval == 'System-3'){
         var variantId = $('.ProductSelect-product-template.system-3').val();
      
        }else if(selectval == 'System-4'){
         var variantId = $('.ProductSelect-product-template.system-4').val();
        }
      
    }else if($('#currentSelection').length){
      var variantId = $('#currentSelection').attr('data-variant'); 
    }else if(variantTitle) {
		var variantId = $('#ProductSelect-product-template option:contains("'+ variantTitle +'")').attr('value');
	} else {
		var variantId = $('#ProductSelect-product-template').val();
	}

	var $option = $('.ProductSelect-product-template option[value="'+variantId+'"]');

	// Check if bundled
	if($option.attr('data-bundled-variant-ids')) {
		var bundledVariantIds = $option.attr('data-bundled-variant-ids').split(',');

		// Updated bundled variants array
		$.each(bundledVariantIds, function(key,val) {
			if(val && val !== "0") bundledVariants.push(val);
		});
	}
    
}


$('#AddToCart-button-main').click(function(event) {

    event.preventDefault();
    checkBundledVariants();
    
  
  	if(bundledVariants.length <= 0 && !$('#AirconSystemSelect-product-template').length ) {
      window.location.href = $(this).attr('href');
      return;
  	}
  
	var productTitle = $('.product-single__title').text();
    if($('#AirconSystemSelect-product-template').length){
      //var selectval = $("#AirconSystemSelect-product-template").val();
      var selectval = $('input[name="aircon_select"]:checked').val();
       if(selectval == 'System-2'){
         var variantId = $('.ProductSelect-product-template.system-2').val();
       
        }else if(selectval == 'System-3'){
         var variantId = $('.ProductSelect-product-template.system-3').val();
      
        }else if(selectval == 'System-4'){
         var variantId = $('.ProductSelect-product-template.system-4').val();
        }
      
    }else if($('#currentSelection').length){
      var variantId = $('#currentSelection').attr('data-variant'); 
    }else{
      var variantId = $('#ProductSelect-product-template.product-form__variants2').val();
    }
  
  	if(variantId == ''){
       alert("Please select the system combination.");
      //$(".syscombi").addClass("active");
      //$("#AirconSystem-Display").addClass("empty");
      //$(".AirconSystem-select").toggleClass("active");
      return false
    }
  
	var variantTitle = $('.ProductSelect-product-template option[value="'+variantId+'"]').data('title');
	var variantPrice = $('.ProductSelect-product-template option[value="'+variantId+'"]').data('price').replace(/,(?=\d{3})/g, '');
    var prodQuantity = $("#currentSelection").attr("data-quantity");
  
	var mainProduct = {
		quantity: prodQuantity,
		id: variantId,
		properties: {}
	}
    // check for groupsell
    var Groupsell =  $('.selectedgroupsell').text();
    if(Groupsell != ''){
      var GroupsellProduct = {
    		quantity: prodQuantity,
    		id: Groupsell,
    		properties: {}
    	}
    	var itemsToAdd = [mainProduct,GroupsellProduct];
    }else{
      var itemsToAdd = [mainProduct];
    }
	// Pre-order properties
	if($('#preorderProperty').length) {
		var preorderProperty = $('#preorderProperty').val();
		mainProduct.properties[preorderProperty] = 1;
	}
    //console.log(bundledVariants)
	// Bundled product
	if(bundledVariants.length > 0) {
		var bundleId = Date.now();
     //CF instalation sku
    if ($('#prism-oasis-pro-8662936355043').length > 0 || $('#prism-oasis-8662929572067').length > 0 || $('#prism-oasis-pro-macaron-8837866651875').length > 0) {
     //bundledVariants.push("45530308247779");
    }

		mainProduct.properties['Bundle ID'] = bundleId

		var bundleProduct = {
			quantity: prodQuantity,
			id: null,
			properties: {
				'Bundle ID': bundleId, // for Grouping
				'Bundled with': productTitle // for identifying bundled product
			}
		};
        if(Groupsell != ''){
        	var itemsToAdd = [mainProduct,GroupsellProduct];
        }else{
            var itemsToAdd = [mainProduct];
          }
       
		$.each(bundledVariants, function(key,val) {
			var product = { ...bundleProduct };
			product.id = val;
          
            var bundle_data = val.split('-');
			product.id = bundle_data[0];
			if(bundle_data[1]){
				product.quantity = bundle_data[1];
			}
	
			itemsToAdd.unshift(product);
		});
    
	}
  

	var contentName = `${productTitle}`;
	if(variantTitle !== 'Default Title') contentName += ` - ${variantTitle}`;

	// FB Pixel
	var fbqObj = {
		content_name: contentName,
		content_category: meta.product.type,
		content_ids: [meta.product.id],
		content_type: 'product_group',
		value: variantPrice,
		num_items: prodQuantity,
		currency: 'SGD'
	};
  //console.log(fbqObj);
  //console.log(fbq)
	if(typeof fbq !== 'undefined' && fbq) fbq('track', 'AddToCart', fbqObj);
	fbq = null;
	
    //TikTok Pixel
  
    var pri=variantPrice.replace(/\,/g,''); // 1125, but a string, so convert it to number
	pri=parseInt(pri,10);

	var ttqObj = {
		content_name: contentName,
		content_category: meta.product.type,
		content_id: meta.product.id,
		content_type: 'product_group',
		value: pri,
		quantity: prodQuantity,
		currency: 'SGD'
	};
    if(ttq) ttq.track('AddToCart', ttqObj)
    //console.log(itemsToAdd)
	// Post to cart
	var params = {
		type: 'POST',
		url: '/cart/add.js',
		data: {items: itemsToAdd},
	    dataType: 'json',
		success: function(line_item) {
			//window.location.href = "/cart";
          cartTotal();
          initExperiment();
		},
		error: function(XMLHttpRequest, textStatus) {
          typeOfPopup = 'error';
			//window.location.reload();
			console.log('Error adding to cart');
			console.log(XMLHttpRequest);
			console.log(textStatus);
		}
	};
	$.ajax(params);

});

let typeOfPopup = 'success';
function addHelperClass() {
  const $main = $('main');
		$main.addClass('js--experiment-active');
	}
function initExperiment() {
		addHelperClass();
		insertPopup();
		closeFunctionality();
		listenForWindowChanges();
		redirectFromBtnsToCart();
	}
function listenForWindowChanges() {
		$(window).on('resize', adjustPopupTop);
	}

	function adjustPopupTop() {
		const $popup = $('.omni-add-to-cart');
		const headerOffset = getHeaderOffset();

		$popup.css('top', headerOffset);
	}

	function getHeaderOffset() {
		const $headerHeight = $('#shopify-section-header').outerHeight();
		const $buyNowBannerOffset = $('.nav2').outerHeight();

		return $headerHeight - $buyNowBannerOffset;
	}

	function insertPopup() {
		const $template = getPopupTemplate(typeOfPopup);
		const $target = $('#PageContainer');

		$target.prepend($template);

		/* We adjust the top padding of the popup here since we don't want full screen popup */
		adjustPopupTop();
	}

	function closeFunctionality() {
		const $closeBtn = $('.omni-add-to-cart__close');

		$closeBtn.on('click', () => {
			removePopup();
		});
	}

	function redirectFromBtnsToCart() {
		const $viewCartBtn = $('.omni-add-to-cart__content-cta-view');
		const $continueBtn = $('.omni-add-to-cart__content-cta-continue');

		$viewCartBtn.on('click', redirectToCart);
		$continueBtn.on('click', removePopup);
	}

	function redirectToCart() {
		window.location.href = '/cart';
	}

	function removePopup() {
		$('.omni-add-to-cart').remove();
		$main.removeClass('js--experiment-active');
	}
function cartTotal(){
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
  //the cart info is in the callback. the item_count is available as part of the callback
  //below I set my cartcount div with the current cart item_count
  var carttext=cart.total_price;
  var cartprice = JSON.stringify(carttext) 
  //jQuery("div#CartCount .cart-total").text(carttext);
  //var cartext2 = Shopify.formatMoney(carttext, "{{ shop.currency }}");
  var cartpricetext = cartprice.substring(0,cartprice.length - 2).toLocaleString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  //console.log(cartpricetext);
  jQuery("div#CartCount .cart-total").text("$"+cartpricetext);  
});
}
function getPopupTemplate(type) {
		const $currentSelectionItem = $('#currentSelection');
		const isSuccess = type === 'success';
		const popupTitle = isSuccess ? 'Do you want to add another fan?' : 'Item not added to Shopping Cart';
		const message = isSuccess ? '70% of customers buy more than 1 fan for their homes to beat the heat!' : 'An error occured.Product not added to cart';
		const size = $currentSelectionItem.find('.type').text().trim();
		const ledColor = $currentSelectionItem.find('.housing').text().trim().split('Motor')[0];
		const color = $currentSelectionItem.find('.blade').text().trim().split('Blade')[0];
		const discountedPrice = $('#ProductPrice-product-template').text().trim();
		const originalPrice = $('#ComparePrice-product-template-oasis').text().trim();
        var variantRestock = $('#currentSelection').attr("data-restock");
        
        var defaultRestock = $('#currentSelection').attr("data-defrestock");
        if(variantRestock != ''){
          var updatedRestock = variantRestock;
        }else{
          var updatedRestock = defaultRestock;
        }
		const productImageSrc = $('#FeaturedImage-product-template-oasis').attr('src') ||
			'https://cdn.shopify.com/s/files/1/1595/6213/products/Oasis-Thumb-Smart-Black-Black_530x@2x.png?v=1667805753';

		return $(`
			<div class="omni-add-to-cart">
				<div class="omni-add-to-cart__popup">
					<div class="omni-add-to-cart__close">
						<img src="//cdn-x.omniconvert.com/public/uploads/2023-02/5ab0e892198f1a1c5b9cbb5c1053f5de.svg" alt="Close">
					</div>
					<div class="omni-add-to-cart__title">${popupTitle}</div>
					<div class="omni-add-to-cart__message omni-add-to-cart__message--${type}">
                       <!-- 
						<img src="//cdn-x.omniconvert.com/public/uploads/2023-02/a7c0ec74e64f2ae74149457ff4d44b8a.svg" alt="Icon">
                      -->
						<span class="omni-add-to-cart__message-text">${message}</span>
					</div>
					<div class="omni-add-to-cart__content">
						<div class="omni-add-to-cart__content-inner">
							<div class="omni-add-to-cart__content-image">
								<img src="${productImageSrc}" alt="Fan">
							</div>
							<div class="omni-add-to-cart__content-details">
								<div class="omni-add-to-cart__content-details-title">PRISM+ Oasis</div>
								<div>Size: <span class="omni-add-to-cart__content-details-size-value">${size}</span></div>
								<div>LED Housing Color: <span class="omni-add-to-cart__content-details-led-value">${ledColor}</span></div>
								<div>Color: <span class="omni-add-to-cart__content-details-color-value">${color}</span></div>
                                <div><b>${updatedRestock}</b></div>
							</div>
							<div class="omni-add-to-cart__content-price">
								<div class="omni-add-to-cart__content-price-discounted">${discountedPrice}</div>
								<div class="omni-add-to-cart__content-price-original">
									<span class="omni-add-to-cart__content-price-original-value">${originalPrice}</span>
									<span class="color-red">(save 25%)</span>
								</div>
							</div>
						</div>
						<div class="omni-add-to-cart__content-ctas">
							<button type="button" class="omni-add-to-cart__content-cta-continue">Continue Shopping</button>
							<button type="button" class="omni-add-to-cart__content-cta-view">View Cart</button>
						</div>
					</div>
				</div>
			</div>
		`);
	}

